import React from 'react';
import { useNavigate } from 'react-router-dom';
import OverviewCardShell, { OverviewTextAction } from './OverviewCardShell';
import styles from './StandardOverview.module.css';
import { OVERVIEW_DUMMY_FIELDS } from './overviewDummyFields';

const ObservationsCard = ({ model }) => {
    const navigate = useNavigate();
    const view = model.observationsView;
    const count = view?.count ?? model.observationCount;

    if (view) {
        return (
            <OverviewCardShell
                title="Observations"
                tall
                headerAside={view.headerMeta ? <span className={styles.cardMetaTiny}>{view.headerMeta}</span> : null}
                footer={<OverviewTextAction onClick={() => navigate('/observations')}>Open Observations →</OverviewTextAction>}>
                <p className={styles.cardMetric}>{count}</p>
                {view.subline ? <p className={styles.cardDescription}>{view.subline}</p> : null}
                {view.preview?.length ? (
                    <ul className={styles.filePreviewList}>
                        {view.preview.map(line => (
                            <li key={line}>{line}</li>
                        ))}
                    </ul>
                ) : null}
            </OverviewCardShell>
        );
    }

    return (
        <OverviewCardShell
            title="Observations"
            footer={<OverviewTextAction onClick={() => navigate('/observations')}>Open Observations →</OverviewTextAction>}>
            {count > 0 ? (
                <>
                    <p className={styles.cardStatus}>{count} observation{count === 1 ? '' : 's'}</p>
                    <p className={styles.cardMutedSmall} title={OVERVIEW_DUMMY_FIELDS.observationsStageLabel}>
                        Early project stage
                    </p>
                </>
            ) : (
                <p className={styles.cardDescription}>No observations yet. Capture findings as project evidence is reviewed.</p>
            )}
        </OverviewCardShell>
    );
};

export default ObservationsCard;
